define([
	"dojo/_base/declare",
	"csi/table/AggregateFrom",
	"csi/xml",
	"csi/xml/Query"
], function(declare,AggregateFrom,xml,Query) {

	return declare(AggregateFrom, {
		_getFixedFilters: function() {
			// summary: filter popup view for materials of specified type
			return new Query()
				.Attr("Usable", xml.OP_EQUALS, true)
				.RefAttr("ProductType", xml.OP_EQUALS, this.widget.get("activeMaterialType"))
				.getElements();
		}
	});
});